export default "__VITE_ASSET__DeQmUyJm__"